// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"b747bca6","453":"a3b2bf1f","934":"53282b7c"}[chunkId] + ".chunk.js";
};